import { render, staticRenderFns } from "./pudePlanList.vue?vue&type=template&id=5c535e19&scoped=true"
import script from "./pudePlanList.vue?vue&type=script&lang=js"
export * from "./pudePlanList.vue?vue&type=script&lang=js"
import style0 from "./pudePlanList.vue?vue&type=style&index=0&id=5c535e19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c535e19",
  null
  
)

export default component.exports